// new-york-date.component.ts
import { Component, OnInit, OnDestroy } from '@angular/core';
import { CustomDatePipe } from '../pipes/new-york-date.pipe';

@Component({
  selector: 'app-new-york-date',
  imports: [ CustomDatePipe],
  template: `
      <span style="color: white; font-family: 'Roboto'; font-weight: 400;font-size: 16px">{{ currentDate | customDate }}</span>
  `
})
export class NewYorkDateComponent implements OnInit, OnDestroy {
  currentDate: Date = new Date();
  private intervalId?: any;

  ngOnInit() {
    this.intervalId = setInterval(() => {
      const now = new Date();
      if (now.getDate() !== this.currentDate.getDate()) {
        this.currentDate = now;
      }
    }, 60000);
  }

  ngOnDestroy() {
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
  }
}
